import React from 'react';
import { func, object } from 'prop-types';
import { translate } from 'react-i18next';
import { inject } from 'mobx-react';

import styles from './styles.scss';

import { Text, TextButton } from 'wix-style-react';

const Footnote = ({ t, biData, biLogger }) => {
  const handleLinkClick = () => {
    biLogger.integrationModalFootNoteClick(biData);
  };
  const handlePrivacyClick = () => {
    handleLinkClick();
    window.open(t('mailchimp.privacy.link'), '_blank', 'noopener noreferrer');
  };
  const handleTermsClick = () => {
    handleLinkClick();
    window.open(t('mailchimp.tos.link'), '_blank', 'noopener noreferrer');
  };
  return (
    <div data-hook="mc-footnote" className={styles.container}>
      <Text size="small" secondary>
        {t('mailchimp.footnote.disclaimer')}
      </Text>
      &nbsp;
      <TextButton size="small" onClick={handleTermsClick}>
        {t('mailchimp.footnote.tos')}
      </TextButton>
      &nbsp;
      <Text size="small" secondary>
        {t('mailchimp.footnote.and')}
      </Text>
      &nbsp;
      <TextButton size="small" onClick={handlePrivacyClick}>
        {t('mailchimp.footnote.privacy.policy')}
      </TextButton>
      .
    </div>
  );
};

Footnote.propTypes = {
  t: func.isRequired,
  biLogger: object.isRequired,
  biData: object.isRequired,
};

export default inject('biLogger')(translate()(Footnote));
